import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const BusinessQuery = gql`
  query {
    business {
      id
      createdAt
      default
      name
      company
      street
      houseNumber
      addressLine1
      addressLine2
      city
      zip
      countyState
      country
      vatNumber
      registrationNumber
      phone
      email
      emailForNotification
      web
      bankName
      iban
      swift
      bankAccountNumber
      countries {
        id
      }
    }
  }
`;

const CreateBusinessMutation = gql`
  mutation($business: BusinessInput!) {
    createBusiness(business: $business) {
      id
    }
  }
`;

const UpdateBusinessMutation = gql`
  mutation($id: String!, $business: BusinessInput!) {
    updateBusiness(id: $id, business: $business) {
      id
    }
  }
`;

const DeleteBusinessMutation = gql`
  mutation($id: String!) {
    deleteBusiness(id: $id) {
      id
    }
  }
`;

interface IInputProps {
  children?: any;
}

interface Response {
  data: any;
}

class GetBusinessQuery extends React.Component<ChildProps<IInputProps, Response>, {}> {
  render() {
    const {
      business,
      createBusiness,
      updateBusiness,
      deleteBusiness
    }: any = this.props;
    return this.props.children({
      business,
      createBusiness,
      updateBusiness,
      deleteBusiness
    });
  }
}

export default compose(
  graphql<IInputProps, Response>(BusinessQuery, {
    name: 'business'
  }),
  graphql<IInputProps, Response>(CreateBusinessMutation, {
    name: 'createBusiness'
  }),
  graphql<IInputProps, Response>(UpdateBusinessMutation, {
    name: 'updateBusiness'
  }),
  graphql<IInputProps, Response>(DeleteBusinessMutation, {
    name: 'deleteBusiness'
  })
)(GetBusinessQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Business/Business.tsx